import { render, staticRenderFns } from "./datastore-detail-control-edit.vue?vue&type=template&id=bfa93b26&"
import script from "./datastore-detail-control-edit.vue?vue&type=script&lang=js&"
export * from "./datastore-detail-control-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports